// extracted by mini-css-extract-plugin
export default {"container":"lsETu0","registrationButtonSpacing":"ouCPe8"};